// ============================================================
// utils/anioEscolar.ts — Helpers para mostrar años escolares
// Soporta múltiples años con la misma cifra pero distinta fase
// (ej: 2026 REGULAR y 2026 RECUPERACION pueden coexistir)
// ============================================================

import { AñoEscolar } from 'types/usuario.types';

export type FaseAnio = 'REGULAR' | 'RECUPERACION';

const FASE_LABEL: Record<FaseAnio, string> = {
  REGULAR:      'Regular',
  RECUPERACION: 'Recuperación',
};

/**
 * Formatea un año escolar como "2026 — Regular" o "2026 — Recuperación".
 * Útil para selectores y dropdowns donde puede haber dos años con la
 * misma cifra pero distinta fase.
 */
export function fmtAnioEscolar(anio: AñoEscolar): string {
  return `${anio.anio} — ${FASE_LABEL[anio.fase] ?? anio.fase}`;
}

/** Formatea solo la fase como etiqueta legible. */
export function fmtFase(fase: FaseAnio | string): string {
  return FASE_LABEL[fase as FaseAnio] ?? fase;
}

/** True si el año es de recuperación (matrículas y pagos cambian). */
export function esAnioRecuperacion(anio: AñoEscolar | null | undefined): boolean {
  return anio?.fase === 'RECUPERACION';
}

/** Color/clase para un badge según la fase. */
export function faseBadgeKind(fase: FaseAnio | string): 'info' | 'warning' {
  return fase === 'RECUPERACION' ? 'warning' : 'info';
}
